export const BRAND_PALETTE = {
  blue: "#6798DD",
  green: "#17A68D",
  pink: "#F5899F",
  red: "#F15450",
  purple: "#9987D0",
}
